import { jQuery } from './utils/jquery.js';
import niceSelectPlugin from './vendors/jquery-nice-select.js';

niceSelectPlugin(jQuery);

jQuery(function ($) {
  cShopInstance = {
    lastSelectedFilters: {},
    preloaderEl: $(".js-wagt-shop-page-preloader"),
    bannerSelects: $("select.js-shop-page-banner-cat-select"),
    shopProductCatSelects: $("select.js-shop-filters-select"),
    productWrapEl: $(".js-wagt-products-loop-wrapper"),
    paginationElSelectorName: ".js-wagt-shop-page-pagination-wrap",
    paginationEl: $(".js-wagt-shop-page-pagination-wrap"),
    ajaxQueue: null,
    taxID: window['product_category'],
    category_ids: [],
    preloader_on: function () {
      // this.preloaderEl.show();
    },
    preloader_off: function () {
      this.preloaderEl.hide();
    },
    is_product_category: function () {
      if (
        typeof window["is_product_category"] != "undefined" &&
        window["is_product_category"]
      ) {
        return true;
      } else {
        return false;
      }
    },
    get_product_category_data: function () {
      if ( typeof window["product_category"] != "undefined" && window["product_category"]
      ) {
        return window["product_category"];
      } else {
        return null;
      }
    },
    displayProducts: function (
      productHtml,
      paginationHtml,
      formData,
      callback
    ) {
      this.productWrapEl.html(productHtml).show();

      // append pagination
      if (typeof paginationHtml != "undefined" && paginationHtml) {
        this.paginationEl.html(paginationHtml).show();
      }

      if (typeof callback != "undefined") {
        callback(formData);
      }
    },
    get_default_vars: function () {
      return {
        page: 0,
        limit: 44,
        sorting: window["sorting"]
      };
    },
    wagt_get_woo_products: function (formData, from) {
      // This method will get product data from system
      if (typeof formData == "undefined" || formData == null || !Object.keys(formData).length ) {
        formData = this.get_default_vars();
      }

      // Extend form data
      formData = $.extend(formData, {
        action: "wagt_get_woo_products"
      });

      if (window["artist_id"]) {
        formData = $.extend(formData, {
          artist_id: window["artist_id"]
        });
      }

      cShopInstance.lastSelectedFilters = formData;

      this.ajaxQueue = $.ajax({
        url: window["wagt_ajax_url"],
        dataType: "json",
        data: formData,
        beforeSend: function () {
          // abort | kill old request
          if (cShopInstance.ajaxQueue != null) {
            cShopInstance.ajaxQueue.abort();
          }
          cShopInstance.preloader_on(); // show preloader
          cShopInstance.productWrapEl.hide(); // hide product wrapper
          cShopInstance.paginationEl.hide(); // hide pagination wrapper
        },
        success: function (res) {
          cShopInstance.preloader_off(); // hide preloader
          cShopInstance.displayProducts(res.products, res.pagination, formData); // display products
          $(document).trigger("manage_shop_select_filters");

          if(from === 'pagination') {
            $("html, body").animate(
              { scrollTop: $(".filters-panel__container").offset().top - 100 },
              500
            );
          }
        },
      });
    },
    shopSidebarFilterEl: $("#js-wagt-shop-filter-sidebar"),
    showSidebarFilter: function () {
      const filterEl = this.shopSidebarFilterEl;
      filterEl.show(0, function () {
        filterEl.addClass("active");
      });
    },
    hideSidebarFilter: function () {
      const filterEl = this.shopSidebarFilterEl;
      filterEl.removeClass("active");
      setTimeout(() => {
        filterEl.hide();
      }, 150);
    },
  };

  // shop item toggle
  $(document).on("click", ".js-shop-sidebar-item-toggle", function () {
    $(this).find("+  ul").slideToggle();
    $(this).toggleClass("active");
  });
  // click event on radio button select in sidebar file
  $(document).on("click", ".js-radio-shop-category-item", function () {
    let checkBox = $(this);
    let isChecked = checkBox.prop("checked");
    let wrapperActiveClass = "active";
    let sameRadioClass = $(this).attr("data-common-class");

    $("." + sameRadioClass)
      .prop("checked", false)
      .trigger("change")
      .parent("label")
      .removeClass(wrapperActiveClass); // uncheck other items

    // re-check
    if (isChecked) {
      checkBox.prop("checked", true);
      checkBox.parent("label").addClass(wrapperActiveClass);
    }
  });
  // event on sidebar search button
  $(document).on("click", ".js-do-search-filters", function () {
    let catIDs = [];
    let priceIDs = [];
    let artistIDs = [];

    setCategoriesFilter('mobile-filter', $(this));
  });

  // do reset sidebar filters
  $(document).on("click", ".js-reset-shop-filters", function () {
    $(".js-radio-shop-category-item").prop("checked", false).trigger("change");
    let formData = cShopInstance.get_default_vars();
    cShopInstance.lastSelectedFilters = formData;
    $('select.wagt-nice-select').val('').niceSelect('update');
    setCategoriesFilter();
    // hide sidebar
    cShopInstance.hideSidebarFilter();
    // fetch products
    cShopInstance.wagt_get_woo_products(formData);
  });

  // manage reset filters on shop page on desktop
  $(document).on("click", ".js-reset-shop-desktop-filters", function () {
    let formData = cShopInstance.get_default_vars();
    $('select.wagt-nice-select').val('').niceSelect('update');
    cShopInstance.wagt_get_woo_products(formData); // fetch products
  });

  // do hide sidebar filter
  $(document).on("click", ".js-close-shop-sidebar-filters", function () {
    cShopInstance.hideSidebarFilter();
  });
  // show shop sidebar filter
  $(document).on("click", ".js-show-shop-sidebar-filters", function () {
    cShopInstance.showSidebarFilter();
  });

  // click event on sorting change to fetch products
  $(document).on("click", ".js-shop-sorting-option", function () {
    cShopInstance.lastSelectedFilters = $.extend(
      cShopInstance.lastSelectedFilters,
      {
        sorting: $(this).attr("data-value"),
      }
    );
    cShopInstance.wagt_get_woo_products(cShopInstance.lastSelectedFilters);
  });

  // hide dropdown of sort
  $(document).on("click", ".js-shop-sorting-option", function () {
    $(this).parent().toggleClass("is-active");
  });

  // get product on click on filter categories
  $(document).on("click", ".js-filters-button", function () {
    if ($(this).hasClass("js-filters-get-all-product")) {
      // get all products on click: get all products
      cShopInstance.wagt_get_woo_products(cShopInstance.get_default_vars());
      return;
    }
    let formData = cShopInstance.lastSelectedFilters;
    let dataID = $(this).attr('data-term-id');

    if ($(this).attr('data-type') == 'category') {
      formData = $.extend(formData, {
        category: dataID,
      });
    }

    if ($(this).attr('data-type') == 'meta_query') {
      formData = $.extend(formData, {
        artist_id: dataID,
      });
    }

    if ($(this).attr('data-type') == 'price') {
      formData = $.extend(formData, {
        price: dataID,
      });
    }

    cShopInstance.wagt_get_woo_products(formData);
  });

  $(document).on('manage_shop_select_filters', 
    function () {
    let emptySelectClass = "wagt-select-blank";
    let filterSelectedClass = "wagt-filter-selected";

    // manage shop filters
    $("select.js-shop-filters-select").each(function (eachIndex, each) {
      let selectEl = $(document)
        .find("div.js-shop-filters-select")
        .eq(eachIndex);

      let resetSelectHtml =
        '<span class="js-reset-shop-select"><svg width="12" height="12" viewBox="0 0 12 12" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M6 7.0312L9.9688 11L11 9.9688L7.0312 6L11 2.0312L9.9688 1L6 4.9688L2.0312 1L1 2.0312L4.9688 6L1 9.9688L2.0312 11L6 7.0312Z" /></svg></span>'; // custom reset button
      selectEl.find("span.current .js-reset-shop-select").remove();

      if (!$(this).val()) {
        // if data is empty
        selectEl.addClass(emptySelectClass);
        selectEl.removeClass(filterSelectedClass);
      } else {
        // if any option is selected
        selectEl.removeClass(emptySelectClass);
        selectEl.addClass(filterSelectedClass);
        selectEl.find("span.current").append(resetSelectHtml);
      }
    });
    // end manage shop filters

    // manage url history
    let newUrl = new URL(window.location);
    if (Object.keys(cShopInstance.lastSelectedFilters).length) {
      for (const property in cShopInstance.lastSelectedFilters) {
        newUrl.searchParams.set(
          property,
          cShopInstance.lastSelectedFilters[property]
        );
      }
    }
    window.history.pushState({}, "", newUrl);
    // end manage url history

    let selectFilterButtonEl = $(".js-select-filter-button");
    selectFilterButtonEl.removeClass("selected");

    // hide and show data based on filter selection
    if (Object.keys(cShopInstance.lastSelectedFilters).length) {
      // check is any category selected
      if (
        typeof cShopInstance.lastSelectedFilters.category != "undefined" &&
        cShopInstance.lastSelectedFilters.category != null &&
        cShopInstance.lastSelectedFilters.category.length ||
        typeof cShopInstance.lastSelectedFilters.artist_id != "undefined" &&
        cShopInstance.lastSelectedFilters.artist_id != null &&
        cShopInstance.lastSelectedFilters.artist_id.length ||
        typeof cShopInstance.lastSelectedFilters.price != "undefined" &&
        cShopInstance.lastSelectedFilters.price != null &&
        cShopInstance.lastSelectedFilters.price.length 
      ) {
        let selectedArray = [];
        selectedArray.push(cShopInstance.lastSelectedFilters.category);
        selectedArray.push(cShopInstance.lastSelectedFilters.artist_id);
        selectedArray.push(cShopInstance.lastSelectedFilters.price);

        // add class on select filter button
        selectFilterButtonEl.addClass("selected");

        $(selectedArray).each(function (
          eachIndex,
          eachVal
        ) {
          $('[value="'+eachVal+'"]').prop("checked", true);
        });
      } else {
        // do uncheck all radio buttons in sidebar filters
        $(".js-radio-shop-category-item").prop("checked", false);
      }
    }
  });

  // Manage reset select Option filter
  $(document).on("click", ".js-reset-shop-select", function () {
    let parentSelectEl = $(this).parent().parent().prev();
    parentSelectEl
      .val(parentSelectEl.find("option:first").val())
      .niceSelect("update");
    parentSelectEl.trigger("change");
  });

  // on shop filter change
  $(document).on("change", 
    "select.js-shop-filters-select", 
    function () {
    setCategoriesFilter('filter', $(this));
  });

  // on shop banner filter change
  $(document).on(
    "change",
    "select.js-shop-page-banner-cat-select",
    function () {
      setCategoriesFilter('banner', $(this));
    }
  );

  /**
   * Set all categories which are filtered
   * @param {String} type    banner|filter
   * @param {Object} element select element
   */
  function setCategoriesFilter(type, element) {

    let catIDs = [];
    let priceIDs = [];
    let artistIDs = [];
    let formData = cShopInstance.lastSelectedFilters; 

    // Banner filter
    cShopInstance.bannerSelects.each(function (index, eachCat) {
      let catId = $(eachCat).val();
      if (typeof catId != "undefined" && catId && catId !== "undefined") {
        catIDs.push(catId);
      }
    });

    // Products filter
    if (type == 'filter' || type == 'banner' && type != 'mobile-filter') {
      cShopInstance.shopProductCatSelects.each(function (index, eachCat) {
        let catId = $(eachCat).val();
        let catType = $(eachCat).attr('data-type');

        if (typeof catId != "undefined" && catId && catId !== "undefined" && catType == 'category') {
          catIDs.push(catId);
        }

        if (typeof catId != "undefined" && catId && catId !== "undefined" && catType == 'meta_query') {
          artistIDs.push(catId);
        }

        if (typeof catId != "undefined" && catId && catId !== "undefined" && catType == 'price') {
          priceIDs.push(catId);
        }
      });
    }

    // Mobile filter
    if (type == 'mobile-filter') {
      $(".js-radio-shop-category-item:checked").each(function (index, eachCat) {
        let catId = $(eachCat).val();
        let catType = $(eachCat).data('type');

        if (typeof catId != "undefined" && catId && catId !== "undefined" && catType == 'category') {
          catIDs.push(catId);
        }

        if (typeof catId != "undefined" && catId && catId !== "undefined" && catType == 'meta_query') {
          artistIDs.push(catId);
        }

        if (typeof catId != "undefined" && catId && catId !== "undefined" && catType == 'price') {
          priceIDs.push(catId);
        }
      });
    }

    formData['page'] = '0';

    if(cShopInstance.taxID) {  
      catIDs.push(cShopInstance.taxID.toString());
    }
    
    formData = $.extend(formData, {
      category: catIDs,
      artist_id: artistIDs,
      price: priceIDs,
    });

    cShopInstance.wagt_get_woo_products(formData);

    if (type == 'filter') {
      let bannerSelectID = element.attr("data-banner-select-id");
      let bannerSelectIDEL = $(bannerSelectID);
      bannerSelectIDEL.val(element.val()).niceSelect("update");
      $(document).trigger("manage_shop_select_filters");
    }

    if (type == 'banner') {
      let selectID = element.attr("data-clone-select-id");
      let changeableSelectEl = $("#shop-filter-" + selectID);
      changeableSelectEl.val(element.val()).niceSelect("update");
    }

    if (type == 'mobile-filter') {
      cShopInstance.hideSidebarFilter();
    }
  }

  // on pagination link click
  $(document).on(
    "click",
    cShopInstance.paginationElSelectorName + " a",
    function () {
      event.preventDefault();
      let url = $(this).attr("href");
      let searchParams = new URL(url).search;
      let pagedArr = searchParams.split("&paged=");
      cShopInstance.lastSelectedFilters = $.extend(
        cShopInstance.lastSelectedFilters,
        {
          page: pagedArr[1],
        }
      );

      cShopInstance.wagt_get_woo_products(cShopInstance.lastSelectedFilters, 'pagination');
      // check if this is on single artist category page then scroll to top
    }
  );

  // manage event when grid size is changed
  $(document).on("gridRangeSliderChange", function (event) {
    let productGridEl = $(".woocommerce-shop .product-grid");
    let productGridClass = productGridEl.attr("class");
    let per_page_count = 48;

    if (productGridEl.hasClass("product-grid_size_big")) {
      per_page_count = 48;
    }
    if (productGridEl.hasClass("product-grid_size_medium")) {
      per_page_count = 48;
    }
    if (productGridEl.hasClass("product-grid_size_small")) {
      per_page_count = 96;
    }
    cShopInstance.lastSelectedFilters = $.extend(
      cShopInstance.lastSelectedFilters,
      {
        limit: per_page_count,
      }
    );
    cShopInstance.wagt_get_woo_products(cShopInstance.lastSelectedFilters);
  });

  // end manage event grid size is changed

  /**
   * fetchResultsOnReadyState
   */
  function fetchResultsOnReadyState() {
    let productFilterOnReadyState = cShopInstance.get_default_vars();

    // set params from url
    let queryString = window.location.search;
    let urlParams = new URLSearchParams(queryString);
    let page = urlParams.get("page");
    let limit = urlParams.get("limit");
    let sorting = urlParams.get("sorting");
    let category = urlParams.get("category");
    let artist_id = urlParams.get("artist_id");
    let price = urlParams.get("price");

    // get page param from url
    if (
      typeof page != "undefined" &&
      page !== "" &&
      page != null &&
      page !== "null"
    ) {
      productFilterOnReadyState = $.extend(productFilterOnReadyState, {
        page: page,
      });
    }

    // artist from url
    if (
      typeof price != "undefined" &&
      price !== "" &&
      price != null &&
      price !== "null"
    ) {
      let selectedPrice = $('.filters-panel__container li[data-value="' + price + '"]').closest('div.wagt-nice-select').prev();
      selectedPrice.val(price).niceSelect('update');
      productFilterOnReadyState['price'] = [price];
    }

    // artist from url
    if (
      typeof artist_id != "undefined" &&
      artist_id !== "" &&
      artist_id != null &&
      artist_id !== "null"
    ) {
      let selectedArtist = $('.filters-panel__container li[data-value="' + artist_id + '"]').closest('div.wagt-nice-select').prev();
      selectedArtist.val(artist_id).niceSelect('update');
      productFilterOnReadyState['artist_id'] = artist_id;
    }

    // get category param from url
    if (
      typeof category != "undefined" &&
      category !== "" &&
      category != null &&
      category !== "null"
    ) {
      productFilterOnReadyState = $.extend(productFilterOnReadyState, {
        category: category.split(","),
      });

      if (productFilterOnReadyState.category.length) {
        for (eachCatIndex in productFilterOnReadyState.category) {
          let selectedVal = productFilterOnReadyState.category[eachCatIndex];
          let selctedCat = $(
            'li[data-value="' + selectedVal + '"]'
          )
            .closest("div.wagt-nice-select")
            .prev();
          selctedCat.val(selectedVal).niceSelect("update");

          let bannerSelectID = selctedCat.attr("data-banner-select-id");
          let bannerSelectIDEL = $(bannerSelectID);
          bannerSelectIDEL.val(selctedCat.val()).niceSelect("update");
          $(document).trigger("manage_shop_select_filters");
        }
      }
    }

    // sorting
    if (
      typeof sorting != "undefined" &&
      sorting !== "" &&
      sorting != null &&
      sorting !== "null"
    ) {
      window["sorting"] = sorting; // replace sorting param in window, param will be set in below condition
    }

    // window['sorting'] will come from default request sorting

    // we need to set sorting option here
    if (typeof window["sorting"] != "undefined" && window["sorting"]) {
      productFilterOnReadyState["sorting"] = window["sorting"];
      // set last selected filters so that other clicks can be mapped
      cShopInstance.lastSelectedFilters = productFilterOnReadyState;
      jQuery("button[data-shop-sorting-option-id=" + window["sorting"]).trigger(
        "click"
      );
      $(".js-shop-sorting-option").parent().removeClass("is-active");
    }

    // also check if this is product category page then default add category filter
    if (cShopInstance.is_product_category()) {
      let pCatData = window['product_category'];
      if (pCatData != null) {
        productFilterOnReadyState["category"] = pCatData;
      }
    }

    // fetch products
    cShopInstance.wagt_get_woo_products(productFilterOnReadyState);
  }

  // call on ready state
  fetchResultsOnReadyState();
});
